/* tslint:disable */
/* eslint-disable */
/**
 * HIV API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: api@vendingontrack.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CheckUserEligibilityResponse
 */
export interface CheckUserEligibilityResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckUserEligibilityResponse
     */
    'eligible'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CheckUserEligibilityResponse
     */
    'coolingOffUntilEpoch'?: number;
}
/**
 * 
 * @export
 * @interface DispenseTestKitRequest
 */
export interface DispenseTestKitRequest {
    /**
     * 
     * @type {string}
     * @memberof DispenseTestKitRequest
     */
    'vendingMachineId'?: string;
}
/**
 * 
 * @export
 * @interface DispenseTestKitResponse
 */
export interface DispenseTestKitResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DispenseTestKitResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DispenseTestKitResponse
     */
    'dispenseId'?: string;
}
/**
 * 
 * @export
 * @interface FindVendingMachineRequest
 */
export interface FindVendingMachineRequest {
    /**
     * 
     * @type {string}
     * @memberof FindVendingMachineRequest
     */
    'machineCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindVendingMachineRequest
     */
    'machineQrcode'?: string;
}
/**
 * 
 * @export
 * @interface FindVendingMachineResponse
 */
export interface FindVendingMachineResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FindVendingMachineResponse
     */
    'found'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FindVendingMachineResponse
     */
    'vendingMachineId'?: string;
    /**
     * 
     * @type {VendingMachineInformation}
     * @memberof FindVendingMachineResponse
     */
    'vendingMachine'?: VendingMachineInformation;
}
/**
 * 
 * @export
 * @interface ListVendingMachinesResponse
 */
export interface ListVendingMachinesResponse {
    /**
     * 
     * @type {Array<VendingMachineInformation>}
     * @memberof ListVendingMachinesResponse
     */
    'vendingMachines'?: Array<VendingMachineInformation>;
}
/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a URL that describes the type of the serialized message.  Protobuf library provides support to pack/unpack Any values in the form of utility functions or additional generated methods of the Any type.  Example 1: Pack and unpack a message in C++.      Foo foo = ...;     Any any;     any.PackFrom(foo);     ...     if (any.UnpackTo(&foo)) {       ...     }  Example 2: Pack and unpack a message in Java.      Foo foo = ...;     Any any = Any.pack(foo);     ...     if (any.is(Foo.class)) {       foo = any.unpack(Foo.class);     }   Example 3: Pack and unpack a message in Python.      foo = Foo(...)     any = Any()     any.Pack(foo)     ...     if any.Is(Foo.DESCRIPTOR):       any.Unpack(foo)       ...   Example 4: Pack and unpack a message in Go       foo := &pb.Foo{...}      any, err := anypb.New(foo)      if err != nil {        ...      }      ...      foo := &pb.Foo{}      if err := any.UnmarshalTo(foo); err != nil {        ...      }  The pack methods provided by protobuf library will by default use \'type.googleapis.com/full.type.name\' as the type URL and the unpack methods only use the fully qualified type name after the last \'/\' in the type URL, for example \"foo.bar.com/x/y.z\" will yield type name \"y.z\".   JSON ==== The JSON representation of an `Any` value uses the regular representation of the deserialized, embedded message, with an additional field `@type` which contains the type URL. Example:      package google.profile;     message Person {       string first_name = 1;       string last_name = 2;     }      {       \"@type\": \"type.googleapis.com/google.profile.Person\",       \"firstName\": <string>,       \"lastName\": <string>     }  If the embedded message type is well-known and has a custom JSON representation, that representation will be embedded adding a field `value` which holds the custom JSON in addition to the `@type` field. Example (for message [google.protobuf.Duration][]):      {       \"@type\": \"type.googleapis.com/google.protobuf.Duration\",       \"value\": \"1.212s\"     }
 * @export
 * @interface ProtobufAny
 */
export interface ProtobufAny {
    [key: string]: object | any;

    /**
     * A URL/resource name that uniquely identifies the type of the serialized protocol buffer message. This string must contain at least one \"/\" character. The last segment of the URL\'s path must represent the fully qualified name of the type (as in `path/google.protobuf.Duration`). The name should be in a canonical form (e.g., leading \".\" is not accepted).  In practice, teams usually precompile into the binary all types that they expect it to use in the context of Any. However, for URLs which use the scheme `http`, `https`, or no scheme, one can optionally set up a type server that maps type URLs to message definitions as follows:  * If no scheme is provided, `https` is assumed. * An HTTP GET on the URL must yield a [google.protobuf.Type][]   value in binary format, or produce an error. * Applications are allowed to cache lookup results based on the   URL, or have them precompiled into a binary to avoid any   lookup. Therefore, binary compatibility needs to be preserved   on changes to types. (Use versioned type names to manage   breaking changes.)  Note: this functionality is not currently available in the official protobuf release, and it is not used for type URLs beginning with type.googleapis.com.  Schemes other than `http`, `https` (or the empty scheme) might be used with implementation specific semantics.
     * @type {string}
     * @memberof ProtobufAny
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface QueryDispenseStatusRequest
 */
export interface QueryDispenseStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof QueryDispenseStatusRequest
     */
    'dispenseId'?: string;
}
/**
 * 
 * @export
 * @interface QueryDispenseStatusResponse
 */
export interface QueryDispenseStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof QueryDispenseStatusResponse
     */
    'inProgress'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueryDispenseStatusResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QueryDispenseStatusResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryDispenseStatusResponse
     */
    'orderState'?: string;
}
/**
 * The `Status` type defines a logical error model that is suitable for different programming environments, including REST APIs and RPC APIs. It is used by [gRPC](https://github.com/grpc). Each `Status` message contains three pieces of data: error code, error message, and error details.  You can find out more about this error model and how to work with it in the [API Design Guide](https://cloud.google.com/apis/design/errors).
 * @export
 * @interface RpcStatus
 */
export interface RpcStatus {
    /**
     * The status code, which should be an enum value of [google.rpc.Code][google.rpc.Code].
     * @type {number}
     * @memberof RpcStatus
     */
    'code'?: number;
    /**
     * A developer-facing error message, which should be in English. Any user-facing error message should be localized and sent in the [google.rpc.Status.details][google.rpc.Status.details] field, or localized by the client.
     * @type {string}
     * @memberof RpcStatus
     */
    'message'?: string;
    /**
     * A list of messages that carry the error details.  There is a common set of message types for APIs to use.
     * @type {Array<ProtobufAny>}
     * @memberof RpcStatus
     */
    'details'?: Array<ProtobufAny>;
}
/**
 * 
 * @export
 * @interface SigninRequest
 */
export interface SigninRequest {
    /**
     * Mobile phone number (required if email not provided)
     * @type {string}
     * @memberof SigninRequest
     */
    'mobile'?: string;
    /**
     * Email address (required if mobile not provided)
     * @type {string}
     * @memberof SigninRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface SigninResponse
 */
export interface SigninResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SigninResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SigninResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof SigninResponse
     */
    'challengeCode'?: string;
}
/**
 * 
 * @export
 * @interface SignupRequest
 */
export interface SignupRequest {
    /**
     * Mobile phone number (required if email not provided)
     * @type {string}
     * @memberof SignupRequest
     */
    'mobile'?: string;
    /**
     * Email address (required if mobile not provided)
     * @type {string}
     * @memberof SignupRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'ageRange'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'countryOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'sexOrientation'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'sexualityOther'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'gender'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'genderOther'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'indigenousStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'australiaResidencyDuration'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SignupRequest
     */
    'testedBefore'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SignupRequest
     */
    'overEighteen'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SignupRequest
     */
    'agreement'?: boolean;
    /**
     * Optional field indicating user\'s consent for data collection and processing
     * @type {boolean}
     * @memberof SignupRequest
     */
    'dataUseAgreement'?: boolean;
}
/**
 * 
 * @export
 * @interface SignupResponse
 */
export interface SignupResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SignupResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SignupResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupResponse
     */
    'challengeCode'?: string;
}
/**
 * 
 * @export
 * @interface VendingMachineInformation
 */
export interface VendingMachineInformation {
    /**
     * 
     * @type {string}
     * @memberof VendingMachineInformation
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof VendingMachineInformation
     */
    'address'?: string;
    /**
     * 
     * @type {number}
     * @memberof VendingMachineInformation
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof VendingMachineInformation
     */
    'latitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof VendingMachineInformation
     */
    'photoUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VendingMachineInformation
     */
    'isOnline'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VendingMachineInformation
     */
    'requireManualSelection'?: boolean;
}
/**
 * 
 * @export
 * @interface VerifyAuthCodeRequest
 */
export interface VerifyAuthCodeRequest {
    /**
     * Mobile phone number (required if email not provided)
     * @type {string}
     * @memberof VerifyAuthCodeRequest
     */
    'mobile'?: string;
    /**
     * Email address (required if mobile not provided)
     * @type {string}
     * @memberof VerifyAuthCodeRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyAuthCodeRequest
     */
    'challengeCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyAuthCodeRequest
     */
    'authCode'?: string;
}
/**
 * 
 * @export
 * @interface VerifyAuthCodeResponse
 */
export interface VerifyAuthCodeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof VerifyAuthCodeResponse
     */
    'loginSuccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VerifyAuthCodeResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyAuthCodeResponse
     */
    'authToken'?: string;
}
/**
 * 
 * @export
 * @interface VerifyEmailTokenRequest
 */
export interface VerifyEmailTokenRequest {
    /**
     * The verification token from the email link
     * @type {string}
     * @memberof VerifyEmailTokenRequest
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface VerifyEmailTokenResponse
 */
export interface VerifyEmailTokenResponse {
    /**
     * 
     * @type {boolean}
     * @memberof VerifyEmailTokenResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VerifyEmailTokenResponse
     */
    'errorMessage'?: string;
    /**
     * JWT authentication token for the verified session
     * @type {string}
     * @memberof VerifyEmailTokenResponse
     */
    'authToken'?: string;
}

/**
 * HivTestAPIServiceApi - axios parameter creator
 * @export
 */
export const HivTestAPIServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if the current user has been blocked or not
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceCheckUserEligibility: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('hivTestAPIServiceCheckUserEligibility', 'body', body)
            const localVarPath = `/api/v1/user-eligibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DispenseTestKitRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceDispenseTestKit: async (body: DispenseTestKitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('hivTestAPIServiceDispenseTestKit', 'body', body)
            const localVarPath = `/api/v1/dispense-testkit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find the vending machine by searching the 4-digit code
         * @param {FindVendingMachineRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceFindVendingMachine: async (body: FindVendingMachineRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('hivTestAPIServiceFindVendingMachine', 'body', body)
            const localVarPath = `/api/v1/find-vending-machine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceListVendingMachines: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/vending-machines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueryDispenseStatusRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceQueryDispenseStatus: async (body: QueryDispenseStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('hivTestAPIServiceQueryDispenseStatus', 'body', body)
            const localVarPath = `/api/v1/dispenses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SigninRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceSignin: async (body: SigninRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('hivTestAPIServiceSignin', 'body', body)
            const localVarPath = `/api/v1/signin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignupRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceSignup: async (body: SignupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('hivTestAPIServiceSignup', 'body', body)
            const localVarPath = `/api/v1/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyAuthCodeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceVerifyAuthCode: async (body: VerifyAuthCodeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('hivTestAPIServiceVerifyAuthCode', 'body', body)
            const localVarPath = `/api/v1/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify an email verification token from a link click
         * @param {VerifyEmailTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceVerifyEmailToken: async (body: VerifyEmailTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('hivTestAPIServiceVerifyEmailToken', 'body', body)
            const localVarPath = `/api/v1/verify-email-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HivTestAPIServiceApi - functional programming interface
 * @export
 */
export const HivTestAPIServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HivTestAPIServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check if the current user has been blocked or not
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hivTestAPIServiceCheckUserEligibility(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckUserEligibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hivTestAPIServiceCheckUserEligibility(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DispenseTestKitRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hivTestAPIServiceDispenseTestKit(body: DispenseTestKitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DispenseTestKitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hivTestAPIServiceDispenseTestKit(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find the vending machine by searching the 4-digit code
         * @param {FindVendingMachineRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hivTestAPIServiceFindVendingMachine(body: FindVendingMachineRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindVendingMachineResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hivTestAPIServiceFindVendingMachine(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hivTestAPIServiceListVendingMachines(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListVendingMachinesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hivTestAPIServiceListVendingMachines(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {QueryDispenseStatusRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hivTestAPIServiceQueryDispenseStatus(body: QueryDispenseStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueryDispenseStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hivTestAPIServiceQueryDispenseStatus(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SigninRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hivTestAPIServiceSignin(body: SigninRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SigninResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hivTestAPIServiceSignin(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SignupRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hivTestAPIServiceSignup(body: SignupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hivTestAPIServiceSignup(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {VerifyAuthCodeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hivTestAPIServiceVerifyAuthCode(body: VerifyAuthCodeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyAuthCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hivTestAPIServiceVerifyAuthCode(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verify an email verification token from a link click
         * @param {VerifyEmailTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hivTestAPIServiceVerifyEmailToken(body: VerifyEmailTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyEmailTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hivTestAPIServiceVerifyEmailToken(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HivTestAPIServiceApi - factory interface
 * @export
 */
export const HivTestAPIServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HivTestAPIServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Check if the current user has been blocked or not
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceCheckUserEligibility(body: object, options?: any): AxiosPromise<CheckUserEligibilityResponse> {
            return localVarFp.hivTestAPIServiceCheckUserEligibility(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DispenseTestKitRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceDispenseTestKit(body: DispenseTestKitRequest, options?: any): AxiosPromise<DispenseTestKitResponse> {
            return localVarFp.hivTestAPIServiceDispenseTestKit(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find the vending machine by searching the 4-digit code
         * @param {FindVendingMachineRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceFindVendingMachine(body: FindVendingMachineRequest, options?: any): AxiosPromise<FindVendingMachineResponse> {
            return localVarFp.hivTestAPIServiceFindVendingMachine(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceListVendingMachines(options?: any): AxiosPromise<ListVendingMachinesResponse> {
            return localVarFp.hivTestAPIServiceListVendingMachines(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueryDispenseStatusRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceQueryDispenseStatus(body: QueryDispenseStatusRequest, options?: any): AxiosPromise<QueryDispenseStatusResponse> {
            return localVarFp.hivTestAPIServiceQueryDispenseStatus(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SigninRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceSignin(body: SigninRequest, options?: any): AxiosPromise<SigninResponse> {
            return localVarFp.hivTestAPIServiceSignin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignupRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceSignup(body: SignupRequest, options?: any): AxiosPromise<SignupResponse> {
            return localVarFp.hivTestAPIServiceSignup(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VerifyAuthCodeRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceVerifyAuthCode(body: VerifyAuthCodeRequest, options?: any): AxiosPromise<VerifyAuthCodeResponse> {
            return localVarFp.hivTestAPIServiceVerifyAuthCode(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify an email verification token from a link click
         * @param {VerifyEmailTokenRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hivTestAPIServiceVerifyEmailToken(body: VerifyEmailTokenRequest, options?: any): AxiosPromise<VerifyEmailTokenResponse> {
            return localVarFp.hivTestAPIServiceVerifyEmailToken(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HivTestAPIServiceApi - object-oriented interface
 * @export
 * @class HivTestAPIServiceApi
 * @extends {BaseAPI}
 */
export class HivTestAPIServiceApi extends BaseAPI {
    /**
     * 
     * @summary Check if the current user has been blocked or not
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HivTestAPIServiceApi
     */
    public hivTestAPIServiceCheckUserEligibility(body: object, options?: AxiosRequestConfig) {
        return HivTestAPIServiceApiFp(this.configuration).hivTestAPIServiceCheckUserEligibility(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DispenseTestKitRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HivTestAPIServiceApi
     */
    public hivTestAPIServiceDispenseTestKit(body: DispenseTestKitRequest, options?: AxiosRequestConfig) {
        return HivTestAPIServiceApiFp(this.configuration).hivTestAPIServiceDispenseTestKit(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find the vending machine by searching the 4-digit code
     * @param {FindVendingMachineRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HivTestAPIServiceApi
     */
    public hivTestAPIServiceFindVendingMachine(body: FindVendingMachineRequest, options?: AxiosRequestConfig) {
        return HivTestAPIServiceApiFp(this.configuration).hivTestAPIServiceFindVendingMachine(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HivTestAPIServiceApi
     */
    public hivTestAPIServiceListVendingMachines(options?: AxiosRequestConfig) {
        return HivTestAPIServiceApiFp(this.configuration).hivTestAPIServiceListVendingMachines(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueryDispenseStatusRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HivTestAPIServiceApi
     */
    public hivTestAPIServiceQueryDispenseStatus(body: QueryDispenseStatusRequest, options?: AxiosRequestConfig) {
        return HivTestAPIServiceApiFp(this.configuration).hivTestAPIServiceQueryDispenseStatus(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SigninRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HivTestAPIServiceApi
     */
    public hivTestAPIServiceSignin(body: SigninRequest, options?: AxiosRequestConfig) {
        return HivTestAPIServiceApiFp(this.configuration).hivTestAPIServiceSignin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignupRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HivTestAPIServiceApi
     */
    public hivTestAPIServiceSignup(body: SignupRequest, options?: AxiosRequestConfig) {
        return HivTestAPIServiceApiFp(this.configuration).hivTestAPIServiceSignup(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VerifyAuthCodeRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HivTestAPIServiceApi
     */
    public hivTestAPIServiceVerifyAuthCode(body: VerifyAuthCodeRequest, options?: AxiosRequestConfig) {
        return HivTestAPIServiceApiFp(this.configuration).hivTestAPIServiceVerifyAuthCode(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify an email verification token from a link click
     * @param {VerifyEmailTokenRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HivTestAPIServiceApi
     */
    public hivTestAPIServiceVerifyEmailToken(body: VerifyEmailTokenRequest, options?: AxiosRequestConfig) {
        return HivTestAPIServiceApiFp(this.configuration).hivTestAPIServiceVerifyEmailToken(body, options).then((request) => request(this.axios, this.basePath));
    }
}


